function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Object module.
 * @module src/object
 * @see src/url
 */
import { decodeURL } from './url';
/**
 * Returns if the value is an Object instance or not.
 *
 * @function isObject
 *
 * @param {any} value - The value to be tested if it is an object or not.
 * @return {boolean} If the value is an Object or not.
 *
 * @example
 * isObject([]);
 * // returns false
 *
 * @example
 * isObject(new Date(1985, 5, 30));
 * // returns false
 *
 * @example
 * isObject('Hello');
 * // returns false
 *
 * @example
 * isObject({a: 1, b: 3});
 * // returns true
 *
 */

export const isObject = value => Object.prototype.toString.call(value) === '[object Object]';
/**
 * Returns if an object is empty or not
 *
 * @function isEmptyObject
 *
 * @param {any} object  - The value to checked if is an object `{}` or not
 * @return {boolean} if the object is empty or not
 *
 * @example
 * isEmptyObject({});
 * // returns true
 *
 * @example
 * isEmptyObject({ a: 1 });
 * // returns false
 *
 * @example
 * isEmptyObject([]);
 * // returns false
 *
 * @example
 * isEmptyObject(null);
 * // returns false
 *
 * @example
 * isEmptyObject('');
 * // returns false
 *
 *
 */

export const isEmptyObject = object => isObject(object) && Object.keys(object).length === 0;
/**
 * Returns an object with the original values transformed.
 *
 * @function transformObjectValues
 *
 * @param {object} object - The object to have its values transformed.
 * @param {function} transformFunction - The function which will transform the values.
 * @return {object} a new object containing the same keys with respective values transformed.
 *
 * @example
 * transformObjectValues({a: 1, b: 2}, (number) => number * 2);
 * // returns { a: 2, b: 4 }
 *
 * @example
 * transformValues({firstName: 'Bruno', lastName: 'Vicenzo'}, (name) => name.toUpperCase());
 * // returns { firstName: 'BRUNO', lastName: 'VICENZO' }
 *
 */

export const transformObjectValues = (object, transformFunction) => {
  const entries = Object.entries(object).map(entry => {
    const _entry = _slicedToArray(entry, 2),
          key = _entry[0],
          value = _entry[1];

    return [key, transformFunction(value)];
  });
  return Object.fromEntries(entries);
};
/**
 * Returns an object with all its URLs decoded.
 *
 * @function decodeObjectUrls
 *
 * @param {object} object - The object to have URLs transformed.
 * @return {object} The object with URLs transformed.
 *
 * @example
 * const object = {
 *   site: {
 *     name: 'Fretadão',
 *     address: 'https%3A%2F%2Ffretadao.com.br'
 *     subSites: [
 *       {
 *         name: 'DHL',
 *         address: 'https%3A%2F%2Ffretadao.com.br%2Fempresas%3Fname%3DDHL'
 *       }
 *     ]
 *   }
 * };
 * decodeObjectUrls(object);
 * // returns
 * // {
 * //   site: {
 * //     name: 'Fretadão',
 * //     address: 'http://fretadao.com.br'
 * //     subSites: [
 * //       {
 * //         name: 'DHL',
 * //         address: 'https://fretadao.com.br/empresas?name=DHL'
 * //       }
 * //     ]
 * //   }
 * // }
 *
 */

export const decodeObjectUrls = object => {
  if (isObject(object)) {
    return transformObjectValues(object, decodeObjectUrls);
  } else if (Array.isArray(object)) {
    return object.map(element => decodeObjectUrls(element));
  } else if (typeof object === 'string') {
    return decodeURL(object);
  } else {
    return object;
  }
};